import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/nextjs/components/CookieBanner.jsx");
;
import(/* webpackMode: "eager" */ "/app/packages/nextjs/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/packages/nextjs/styles/globals.css");
